/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';
import { media } from '@atlassian/bitkit-responsive';

import { CenteredColumn } from 'src/styles';

export const CommitStat = styled.span({
  '& + &': {
    marginLeft: `${gridSize() * 2}px`,
  },
});

export const PaginationContainer = styled.div({
  padding: `${gridSize()}px 0`,
});

export const CommitListContainer = styled.div({
  display: 'flex',
  position: 'relative',
  minHeight: '100px',
  marginBottom: `${gridSize() * 4}px`,
});

export const CommitGraphContainer = styled.div(
  media.upToLarge(`
    display: none;
  `),
  {
    boxSizing: 'border-box',
    paddingRight: `${gridSize() * 2}px`,
    display: 'flex',
    justifyContent: 'flex-end',
  }
);

export const EmptyResults = styled(CenteredColumn)({
  marginTop: `${gridSize() * 4}px`,
});

// Custom style needed to properly align the tag before icon
export const CommitListTag = styled.div({
  'span > span': {
    marginTop: `${gridSize() / 8}px`,
    marginLeft: `${gridSize() / 4}px`,
  },
});
